export default "__VITE_ASSET__79d0bfea__"